(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[328],{

/***/ 3552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Loaders_FullScreenLoader_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5815);
/* harmony import */ var _Auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1391);
/* harmony import */ var _context_AuthContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8760);
/* harmony import */ var _PrivateRoute_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7361);
/* harmony import */ var _PrivateRoute_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_PrivateRoute_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const PrivateRoute = (props)=>{
    const { authLoading , user  } = (0,_context_AuthContext__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    if (authLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loaders_FullScreenLoader_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        isLoading: true
    });
    if ((0,_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .isEmptyObject */ .Qr)(user)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_PrivateRoute_module_scss__WEBPACK_IMPORTED_MODULE_6___default().authWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Auth__WEBPACK_IMPORTED_MODULE_3__/* .Auth */ .g, {})
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: props.children
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (PrivateRoute);


/***/ }),

/***/ 5559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3935);
/* harmony import */ var _icons_close__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2645);
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7463);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2145);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const Modal = (props)=>{
    const { isMobile  } = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const initialStyles = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const defaultSize = isMobile ? 90 : 80;
        return {
            width: props.width || "".concat(defaultSize, "vw"),
            height: props.height || "".concat(defaultSize, "vh"),
            ...props.styles
        };
    }, [
        props
    ]);
    const [container, setContainer] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (typeof document !== "undefined") {
            const modalRoot = document.getElementById("portal-modal");
            if (!container) {
                const newContainer = document.createElement("div");
                setContainer(newContainer);
                modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.appendChild(newContainer);
            }
            return ()=>{
                if (container) {
                    modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.removeChild(container);
                }
            };
        }
    }, [
        container
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleEscape = (e)=>{
            if (props.toggleModal && e.key === "Escape") {
                props.toggleModal();
            }
        };
        if (props.isOpen) {
            window.addEventListener("keydown", handleEscape);
        }
        return ()=>{
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        props
    ]);
    const renderModalContent = ()=>{
        return props.isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dialog", {
            className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContainer),
            onClick: props.toggleModal,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: initialStyles,
                onClick: (e)=>e.stopPropagation(),
                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalBody),
                children: [
                    props.showHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalHeader),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headerContent),
                                children: props.headerContent ? props.headerContent : null
                            }),
                            !props.hideCloseButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().closeIcon),
                                onClick: props.toggleModal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_close__WEBPACK_IMPORTED_MODULE_3__/* .CloseIcon */ .T, {
                                    color: "#e1c7fb"
                                })
                            })
                        ]
                    }),
                    props.children
                ]
            })
        }) : null;
    };
    return container ? /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(renderModalContent(), container) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 4958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Typography/Brand/Brand.tsx
var Brand = __webpack_require__(2737);
// EXTERNAL MODULE: ./components/Modal/Modal.tsx
var Modal = __webpack_require__(5559);
// EXTERNAL MODULE: ./services/files.ts
var files = __webpack_require__(2420);
// EXTERNAL MODULE: ./utils/arrays.ts
var arrays = __webpack_require__(91);
// EXTERNAL MODULE: ./context/AuthContext.tsx
var AuthContext = __webpack_require__(175);
// EXTERNAL MODULE: ./services/users.ts
var users = __webpack_require__(7077);
// EXTERNAL MODULE: ./context/ToastContext.tsx
var ToastContext = __webpack_require__(5887);
// EXTERNAL MODULE: ./components/Inputs/InputText/InputText.tsx
var InputText = __webpack_require__(2469);
// EXTERNAL MODULE: ./components/EditProfileForm/EditProfileForm.module.scss
var EditProfileForm_module = __webpack_require__(9825);
var EditProfileForm_module_default = /*#__PURE__*/__webpack_require__.n(EditProfileForm_module);
// EXTERNAL MODULE: ./components/buttons/ButtonSecondary/ButtonSecondary.tsx
var ButtonSecondary = __webpack_require__(749);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-19.js
var bucket_19 = __webpack_require__(5090);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-15.js
var bucket_15 = __webpack_require__(2522);
;// CONCATENATED MODULE: ./components/EditProfileForm/EditProfileForm.tsx











const EditProfileForm = ()=>{
    const { user , loadUser  } = (0,AuthContext/* useAuth */.aC)();
    const { showSuccessAlert , showErrorAlert  } = (0,ToastContext/* useToastContext */.a)();
    const [newAvatar, setNewAvatar] = (0,react.useState)(null);
    const [name, setName] = (0,react.useState)(InputText/* initialText */.WG);
    const [bio, setBio] = (0,react.useState)(InputText/* initialText */.WG);
    const [loading, setLoading] = (0,react.useState)(false);
    const [formValid, setFormValid] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (user) {
            setName({
                ...name,
                value: user.name
            });
            setBio({
                ...bio,
                value: user.bio || ""
            });
        }
    }, [
        user
    ]);
    (0,react.useEffect)(()=>{
        setFormValid(name.value && (0,arrays/* isAllTrue */.IE)(name.validators) && (0,arrays/* isAllTrue */.IE)(bio.validators) || false);
    }, [
        name,
        bio
    ]);
    const handleFormSubmit = async (event)=>{
        event.preventDefault();
        const newUser = {
            ...user,
            name: name.value,
            bio: bio.value
        };
        setLoading(true);
        try {
            if (newAvatar) {
                const response = await (0,files/* uploadFileToServer */.w)(newAvatar, "avatars");
                if (response.success) {
                    newUser.avatar = response.data;
                } else {
                    showErrorAlert("Error uploading the avatar");
                }
            }
            const response1 = await (0,users/* updateUserInfo */.gS)(newUser);
            if (response1.success) {
                showSuccessAlert("User data updated successfully");
                await loadUser(user.email);
                setLoading(false);
            }
        } catch (error) {
            showErrorAlert(error.message || "Error updating user");
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: (EditProfileForm_module_default()).editProfileForm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.ZP, {
                variant: "transparent",
                id: "inputTextEditUserName",
                label: "Full name",
                placeholder: "Username",
                text: name,
                setText: setName,
                isRequired: true,
                minValueLength: 2,
                maxValueLength: 50,
                iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_19/* User */.n5, {
                    size: 24,
                    color: "white",
                    className: "mt-7"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                    size: "lg",
                    loading: loading,
                    disabled: !formValid,
                    onClick: handleFormSubmit,
                    text: "Save changes",
                    className: "w-full",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_15/* Save */.vc, {
                        size: 20
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var EditProfileForm_EditProfileForm = (EditProfileForm);

// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-18.js
var bucket_18 = __webpack_require__(3141);
// EXTERNAL MODULE: ./components/UserProfile/UserProfile.module.scss
var UserProfile_module = __webpack_require__(8790);
var UserProfile_module_default = /*#__PURE__*/__webpack_require__.n(UserProfile_module);
// EXTERNAL MODULE: ./components/Loaders/LoaderCircle/Loader.tsx
var Loader = __webpack_require__(9416);
;// CONCATENATED MODULE: ./components/buttons/Button/Button.tsx



const variantClasses = {
    primary: "bg-[#70B237] text-[#242C36] border border-[#477A1E] hover:bg-[#8FCA5C] hover:border-[#70B237] font-semibold",
    secondary: "bg-[#252238] text-white border border-[#312E47] hover:bg-[#312E47] hover:border-[#6D6D94]",
    danger: "bg-[#da4444] text-white border border-[#b33333] hover:bg-[#e55555] hover:border-[#da4444]",
    ghost: "bg-transparent text-white border border-[#312E47] hover:bg-[#252238] hover:border-[#6D6D94]",
    social: "bg-white text-[#242C36] border border-[#e0e0e0] hover:bg-[#f5f5f5] hover:border-[#c0c0c0] font-medium"
};
const sizeClasses = {
    sm: "h-8 px-3 text-xs gap-1.5",
    md: "h-10 px-4 text-sm gap-2",
    lg: "h-12 px-6 text-base gap-2.5"
};
const iconSizes = {
    sm: 14,
    md: 16,
    lg: 18
};
const Button = (param)=>{
    let { children , variant ="primary" , size ="md" , icon , iconPosition ="left" , loading =false , disabled =false , type ="button" , onClick , className ="" , style , fullWidth =false  } = param;
    const isDisabled = disabled || loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        style: style,
        className: [
            "inline-flex items-center justify-center rounded-lg font-poppins transition-all duration-150 cursor-pointer",
            "disabled:opacity-50 disabled:cursor-not-allowed",
            variantClasses[variant],
            sizeClasses[size],
            fullWidth ? "w-full" : "",
            className
        ].filter(Boolean).join(" "),
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
            isLoading: true,
            width: iconSizes[size],
            height: iconSizes[size],
            color: "white"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                icon && iconPosition === "left" && icon,
                children,
                icon && iconPosition === "right" && icon
            ]
        })
    });
};
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./components/UserProfile/UserProfile.tsx








const UserProfile = ()=>{
    const { user  } = (0,AuthContext/* useAuth */.aC)();
    const { showSuccessAlert , showWarningAlert , showErrorAlert  } = (0,ToastContext/* useToastContext */.a)();
    const confirmRemove = ()=>{
        showWarningAlert("Are you sure you want to delete your account?", "Confirm", handleRemove);
    };
    const handleRemove = ()=>{
        (0,users/* removeUserInfo */.TT)(user.email).then((response)=>{
            if (response) {
                showSuccessAlert("User removed");
                (0,users/* logout */.kS)();
            }
        }).catch((error)=>{
            showErrorAlert(error.message || "Error removing user");
        });
    };
    const DeleteAccount = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button, {
        variant: "danger",
        size: "lg",
        className: "w-full mt-2",
        onClick: confirmRemove,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_18/* TrashCan */.ZN, {
                size: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Delete account"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (UserProfile_module_default()).userProfileContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditProfileForm_EditProfileForm, {}),
            DeleteAccount
        ]
    });
};
/* harmony default export */ var UserProfile_UserProfile = (UserProfile);

// EXTERNAL MODULE: ./components/icons/user.tsx
var icons_user = __webpack_require__(7235);
// EXTERNAL MODULE: ./context/ImagineContext.tsx + 5 modules
var ImagineContext = __webpack_require__(7524);
// EXTERNAL MODULE: ./utils/object.ts
var object = __webpack_require__(8760);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-12.js
var bucket_12 = __webpack_require__(601);
;// CONCATENATED MODULE: ./components/UserCard/UserCard.tsx









const getInitials = (name, email)=>{
    if (name) {
        const parts = name.trim().split(/\s+/);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    }
    if (email) {
        return email.substring(0, 2).toUpperCase();
    }
    return "U";
};
const UserImage = (props)=>{
    const { user  } = (0,AuthContext/* useAuth */.aC)();
    const getImageStyles = ()=>{
        return {
            width: props.size,
            minWidth: props.size,
            maxWidth: props.size,
            height: props.size,
            minHeight: props.size,
            maxHeight: props.size
        };
    };
    const isMsAccount = user.email && user.email.endsWith("@minecraft.local");
    const initials = getInitials(user.name || user.minecraft_username, user.email);
    const size = props.size || "40px";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-10 min-w-10 max-w-10 h-10 min-h-10 max-h-10 cursor-pointer rounded-full flex justify-center items-center",
        style: {
            width: size,
            height: size,
            minWidth: size,
            maxWidth: size,
            minHeight: size,
            maxHeight: size
        },
        children: user.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: user.avatar,
            alt: "avatar",
            className: "w-full h-full rounded-full object-cover",
            loading: "lazy"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full rounded-full bg-[#252238] border border-[#312E47] text-white flex items-center justify-center font-bold text-lg tracking-wide",
            children: isMsAccount ? initials : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_user/* UserIcon */.t, {
                width: props.size || "24px",
                height: props.size || "24px"
            })
        })
    });
};
const UserCard = (props)=>{
    const { user , logout  } = (0,AuthContext/* useAuth */.aC)();
    const { clearResults  } = (0,ImagineContext/* useImagine */.Y)();
    const [showEditModal, setShowEditModal] = (0,react.useState)(false);
    const handleLogout = ()=>{
        clearResults();
        if (user.email && user.email.endsWith("@minecraft.local")) {
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            window.location.href = "/welcome";
        } else {
            logout();
        }
    };
    const cardRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!props.showCard) return;
        const handleOutsideClick = (e)=>{
            if (cardRef.current && !cardRef.current.contains(e.target)) {
                props.setShowCard(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>document.removeEventListener("mousedown", handleOutsideClick);
    }, [
        props.showCard
    ]);
    if ((0,object/* isEmptyObject */.Qr)(user)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            props.showCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: cardRef,
                className: "absolute top-12 right-0 z-50 bg-[#14172D] border border-[#312E47] rounded-xl p-4 flex flex-col gap-4 min-w-[200px] shadow-lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-3 px-4 py-2.5 rounded-lg bg-[#252238] border border-[#312E47] text-white cursor-pointer transition-all duration-150 hover:bg-[#8FCA5C] hover:border-[#8FCA5C] hover:text-[#242C36] group",
                        onClick: (e)=>{
                            e.stopPropagation();
                            setShowEditModal(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_19/* User */.n5, {
                                size: 18
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm font-medium",
                                children: "Edit Profile"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-3 px-4 py-2.5 rounded-lg bg-[#252238] border border-[#312E47] text-white cursor-pointer transition-all duration-150 hover:bg-red-900/30 hover:border-red-500 hover:text-red-400",
                        onClick: (e)=>{
                            e.stopPropagation();
                            handleLogout();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_12/* Logout */.RD, {
                                size: 18
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm font-medium",
                                children: "Log out"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                showHeader: true,
                headerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "headline-4",
                    children: "Edit Profile"
                }),
                width: "auto",
                height: "auto",
                isOpen: showEditModal,
                toggleModal: ()=>setShowEditModal(!showEditModal),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfile_UserProfile, {})
            })
        ]
    });
};
/* harmony default export */ var UserCard_UserCard = (UserCard);

// EXTERNAL MODULE: ./context/SDContext.tsx + 5 modules
var SDContext = __webpack_require__(9498);
// EXTERNAL MODULE: ./components/Navbar/Navbar.module.scss
var Navbar_module = __webpack_require__(5927);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
;// CONCATENATED MODULE: ./components/Navbar/Navbar.tsx








const NavMenu = (props)=>{
    const [showUserCard, setShowUserCard] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Navbar_module_default()).brand,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand/* default */.Z, {
                    onClick: props.redirectToHome
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: (Navbar_module_default()).auth,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Navbar_module_default()).avatarImage,
                        onClick: ()=>setShowUserCard(!showUserCard),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserImage, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Navbar_module_default()).userCardContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCard_UserCard, {
                            showCard: showUserCard,
                            setShowCard: setShowUserCard
                        })
                    })
                ]
            })
        ]
    });
};
const Navbar = (props)=>{
    const router = (0,next_router.useRouter)();
    const { user , setAuthOption  } = (0,AuthContext/* useAuth */.aC)();
    const { selectedOption  } = (0,SDContext/* useDiffusion */.PW)();
    const redirectToHome = (0,react.useCallback)(async ()=>{
        router.push("/");
    }, [
        user,
        router
    ]);
    const redirectToProfile = (0,react.useCallback)(async ()=>{
        router.push("/profile");
    }, [
        router
    ]);
    const handleAuthActionClick = (0,react.useCallback)(async (authOption)=>{
        if (router.pathname !== "") {
            router.push("/");
            setAuthOption(authOption);
        }
        setAuthOption(authOption);
    }, [
        router,
        setAuthOption
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Navbar_module_default()).navbarContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMenu, {
            user: user,
            selectedOption: selectedOption,
            redirectToHome: redirectToHome,
            redirectToProfile: redirectToProfile,
            handleAuthActionClick: handleAuthActionClick,
            isMobile: false,
            showBrand: props.showBrand
        })
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);


/***/ }),

/***/ 2645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const CloseIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: props.width || "32",
        height: props.height || "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.1214 16.0005L27.5615 6.56147C28.1474 5.97549 28.1474 5.02543 27.5615 4.43949C26.9755 3.8535 26.0254 3.8535 25.4395 4.43949L16.0005 13.8795L6.56147 4.43949C5.97549 3.8535 5.02543 3.8535 4.43949 4.43949C3.85355 5.02547 3.8535 5.97553 4.43949 6.56147L13.8795 16.0005L4.43949 25.4395C3.8535 26.0255 3.8535 26.9755 4.43949 27.5615C5.02547 28.1474 5.97553 28.1474 6.56147 27.5615L16.0005 18.1214L25.4394 27.5615C26.0254 28.1474 26.9755 28.1474 27.5614 27.5615C28.1474 26.9755 28.1474 26.0254 27.5614 25.4395L18.1214 16.0005Z",
            fill: props.color || "white"
        })
    });


/***/ }),

/***/ 7463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useWindowDimensions; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./utils/constants.ts
const MOBILE_SCREEN_WIDTH = 768;

;// CONCATENATED MODULE: ./hooks/useWindowDimensions.ts


const useWindowDimensions = ()=>{
    const [windowDimensions, setWindowDimensions] = (0,react.useState)({
        width: undefined,
        height: undefined,
        isMobile: undefined
    });
    (0,react.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
                isMobile: window.innerWidth < MOBILE_SCREEN_WIDTH
            });
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowDimensions;
};
/* harmony default export */ var hooks_useWindowDimensions = (useWindowDimensions);


/***/ }),

/***/ 2420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ uploadFileToServer; }
/* harmony export */ });
/* unused harmony export uploadMultipleFilesToServer */
/* harmony import */ var _httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6230);

const uploadFileToServer = async (file, destFolder)=>{
    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("files/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                folder: destFolder
            }
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const uploadMultipleFilesToServer = async (files)=>{
    try {
        const formData = new FormData();
        files.forEach((file)=>{
            formData.append("files", file);
        });
        const response = await httpInstance.post("files/upload/multiple", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};


/***/ }),

/***/ 7361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authWrapper":"PrivateRoute_authWrapper__0P76s"};

/***/ }),

/***/ 9825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"editProfileForm":"EditProfileForm_editProfileForm__SCqGL","avatarContainer":"EditProfileForm_avatarContainer__pobCP","avatarInput":"EditProfileForm_avatarInput__r5EEP","inputContent":"EditProfileForm_inputContent__vUpNy","button":"EditProfileForm_button__wJuVi"};

/***/ }),

/***/ 2145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"Modal_modalContainer__trqEu","modalBody":"Modal_modalBody__nzWd_","modalHeader":"Modal_modalHeader__1FFG1","headerContent":"Modal_headerContent__ZbKju","closeIcon":"Modal_closeIcon__TiCNm"};

/***/ }),

/***/ 5927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signature":"Navbar_signature__y1l_w","caption-2":"Navbar_caption-2__oQeiw","caption-1":"Navbar_caption-1__1cPKz","base-2":"Navbar_base-2__XIMMc","base-1":"Navbar_base-1__ruTKo","body-3":"Navbar_body-3__lY1_d","body-2":"Navbar_body-2__g_2QD","body-1":"Navbar_body-1__njJiP","headline-6":"Navbar_headline-6__6qUHt","headline-5":"Navbar_headline-5__p3sNW","headline-4":"Navbar_headline-4__d_FLC","headline-3":"Navbar_headline-3__IOiw4","headline-2":"Navbar_headline-2__bjLx4","headline-1":"Navbar_headline-1___y4dF","brand":"Navbar_brand__OGPL_","button":"Navbar_button__0WFsP","bold64":"Navbar_bold64___A5mz","bold40":"Navbar_bold40__a1B4y","heading":"Navbar_heading__oQSJJ","bodyBold":"Navbar_bodyBold__5zGHd","bigBody":"Navbar_bigBody__EUndz","body":"Navbar_body__iTrCe","bold12":"Navbar_bold12__T77gc","boldSmall":"Navbar_boldSmall__Lwo0C","small":"Navbar_small__wzN2F","main":"Navbar_main__KxuSy","accent":"Navbar_accent__BDOg0","primary":"Navbar_primary__La5Qq","secondary":"Navbar_secondary__R4A6_","success":"Navbar_success__kdlIn","info":"Navbar_info__zT77c","danger":"Navbar_danger__p1IPh","white":"Navbar_white__KqaAq","grey":"Navbar_grey__WON6w","black":"Navbar_black__kswvL","mainColor":"Navbar_mainColor__YiWXR","upper":"Navbar_upper__GfPGG","capitalize":"Navbar_capitalize__INjaj","underline":"Navbar_underline__aiB_H","lineThrough":"Navbar_lineThrough__LmJ8A","ellipsis":"Navbar_ellipsis__7odjJ","pointer":"Navbar_pointer__Smy5L","shadow":"Navbar_shadow__r8LjK","center":"Navbar_center__tzhIH","left":"Navbar_left__zEB2_","right":"Navbar_right__NA7Q0","navbarContainer":"Navbar_navbarContainer__un8ww","links":"Navbar_links__xxOpa","activeLink":"Navbar_activeLink__X09aQ","auth":"Navbar_auth__b7l6n","avatarImage":"Navbar_avatarImage__gZ0mW","userCardContainer":"Navbar_userCardContainer__6iYLj","burgerMenuContent":"Navbar_burgerMenuContent__JU_3U","closeIcon":"Navbar_closeIcon__9oO6h"};

/***/ }),

/***/ 8790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"userProfileContainer":"UserProfile_userProfileContainer__KnakE","userProfileNav":"UserProfile_userProfileNav__vuK0K","userProfileContent":"UserProfile_userProfileContent___kOk4","navItem":"UserProfile_navItem__MOfFl","active":"UserProfile_active__lvogL","deleteBtn":"UserProfile_deleteBtn__d_OwU","mobileDeleteAccount":"UserProfile_mobileDeleteAccount__yjVoj"};

/***/ })

}]);